import React from "react";
import "./index.scss";
import { ArrowRight } from "../../../../../assets/images/svg/svg";
import { Link } from "react-router-dom";
import { blogDetail } from "../../../../../utils/router/constant";

const BlogCard = ({
  blogTitle,
  shortDescription,
  blogHeadingImage,
  subtitle,
  imageUrl,
  blogSlug,
}) => {
  return (
    <div className="card blog--card">
      <div className="blog--card--header">
        <h5 className="blog--card--title">{blogTitle}</h5>
        <h6 className="blog--card--subtitle">{subtitle}</h6>
      </div>
      <div className="blog--card--img">
        <img src={imageUrl[0]?.url} />
      </div>
      <div className="blog--card--description">{shortDescription}</div>
      <div className="blog--card--footer">
        <Link to={`${blogDetail}/${blogSlug}`} className="blog--card--link">
          Read More <ArrowRight />
        </Link>
      </div>
    </div>
  );
};

export default BlogCard;
